<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Add Stock Keeping Unit</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help you when you contact us.</h6>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label class="col-sm-3 text-right control-label col-form-label" for="code">
                                SKU Code
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       disabled
                                       id="code"
                                       v-model="product.code">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-3 text-right control-label col-form-label" for="name">
                                Product
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       disabled
                                       id="name"
                                       v-model="product.name">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-3 text-right control-label col-form-label" for="quantity">
                                Quantity
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       disabled
                                       id="quantity"
                                       :value="product.quantity+' '+product.unit + '('+product.symbol+ ')'">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-3 text-right control-label col-form-label" for="description">
                                Description
                            </label>
                            <div class="col-sm-6">
                                <textarea class="form-control"
                                          disabled
                                          id="description"
                                          rows="5"
                                          v-model="product.description">
                                </textarea>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-3 text-right control-label col-form-label" for="creator">
                                Created By
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       disabled
                                       id="creator"
                                       :value="product.first_name+' '+product.last_name + ' ('+product.email+ ')'">
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-sm-3 text-right control-label col-form-label" for="timestamp">
                                Created At
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       disabled
                                       id="timestamp"
                                       :value="product.created_at">
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="form-group m-b-0 text-right">
                            <div class="button-group">
                                <router-link :to="{name: 'editproduct', params: { productid: productid}}"
                                             class="btn waves-effect waves-light btn-success">
                                    Edit
                                </router-link>
                                <button class="btn waves-effect waves-light btn-secondary"
                                        @click="deleteProduct" type="button">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import pad from "pad";

export default {
    name: "MarketplaceSKUDisplay",
    props: [

        "productid"],
    computed: {
        ...mapGetters(["currentUser", "currentOrg"])
    },
    data() {
        return {
            isLoading: false,
            submitted: false,
            product: {
                code: null,
                good: null,
                quantity: null,
                unit: null
            },
            goods: [],
            units: []
        }
    },
    mounted() {
        this.getProduct();
    },
    methods: {
        async getProduct() {
            try {
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/products/${this.productid}`);

                this.product = {
                    code: reply.data.code,
                    name: reply.data.name,
                    description: reply.data.description,
                    quantity: Number(reply.data.quantity),
                    unit: reply.data.unit_name,
                    symbol: reply.data.unit,
                    created_at: this.$options.filters.timestamp(reply.data.created_at),
                    first_name: reply.data.first_name,
                    last_name: reply.data.last_name,
                    email: reply.data.email
                }
            } catch(e) {
                this.$toastr('error', 'Stock Keeping Unit not found', 'Failure');
                this.$router.push({name: "products"});
            }
        },
        async deleteProduct() {
            try {
                await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/products/${this.productid}`);
                this.$toastr('success', 'Stock Keeping Unit Deleted', 'Success');
                this.$router.push({name: "products"});
            } catch(e) {
                this.$toastr('error', 'Stock Keeping Unit Deletion Failed', 'Failure');
            }
        }
    }
}
</script>

<style scoped>

</style>
